import React from "react";
import { Mail } from "lucide-react"; // Using Lucide icons for modern look

const Contact = () => {
  return (
    <section id="contact" className="bg-gray-900 text-white py-20">
      <div className="max-w-4xl mx-auto text-center px-6">
        <h2 className="text-3xl font-bold mb-6">Get in Touch</h2>
        <p className="text-gray-400 mb-8">
          Do you have a question, need assistance, or just want to learn more about Trvllr™? We're here to help.
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Info Email */}
          <div className="p-6 border border-gray-700 rounded-lg bg-gray-800 flex flex-col items-center">
            <Mail className="w-10 h-10 text-purple-400 mb-4" />
            <h3 className="text-lg font-semibold">General Inquiries</h3>
            <a href="mailto:info@trvllrpro.io" className="text-purple-400 hover:text-purple-300">
              info@trvllrpro.io
            </a>
          </div>

          {/* Sales Email */}
          <div className="p-6 border border-gray-700 rounded-lg bg-gray-800 flex flex-col items-center">
            <Mail className="w-10 h-10 text-amber-400 mb-4" />
            <h3 className="text-lg font-semibold">Sales & Partnerships</h3>
            <a href="mailto:sales@trvllrpro.io" className="text-amber-400 hover:text-amber-300">
              sales@trvllrpro.io
            </a>
          </div>

          {/* Support Email */}
          <div className="p-6 border border-gray-700 rounded-lg bg-gray-800 flex flex-col items-center">
            <Mail className="w-10 h-10 text-red-400 mb-4" />
            <h3 className="text-lg font-semibold">Support & Help</h3>
            <a href="mailto:support@trvllrpro.io" className="text-red-400 hover:text-red-300">
              support@trvllrpro.io
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
